import React from 'react';
import { upperFirst } from 'lodash';

import NotificationContent from '../../shared/AppointmentContainer';
import Header from './components/Header';
import Footer from '../../shared/Footer';
import Logo from '../../shared/Logo';
import AppointmentInfo from '../../shared/AppointmentInfo';
import ShopLocation from '../../shared/ShopLocation';
import PhonesBackground from '../../shared/PhonesBackground';
import SquireInfo from '../../shared/SquireInfo';
import withAppointmentNotification from '../../hoc/withAppointmentNotification';
import PostCtaAction from './components/PostCtaAction';
import Cta from './components/Cta';

/* eslint-disable react/prop-types */
const CustomerRebook = ({
  shop,
  date,
  customer,
  confirmationCode,
  barber,
  service,
  address,
  duration,
  appLink,
  squireInfoClassName,
}) => (
  <div>
    <Header shopName={shop.name} />
    <NotificationContent>
      <Logo />
      <div className="u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mt-12">
        Friendly reminder
      </div>
      <h2 className="u-text-huge u-fw-bold u-mt-2 u-mb-10">
        Hey {upperFirst(customer.firstName)}, it&apos;s time to book your next appointment.
      </h2>
      <div className="u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4">
        Previous appointment
      </div>
      <div className="u-flex u-justify-content-space-between u-flex-wrap">
        <AppointmentInfo
          confirmationCode={confirmationCode}
          barberName={`${barber.firstName} ${(barber.lastName || '')[0]}.`}
          service={service}
          date={date}
          duration={duration}
        />
        <div className="c-appointment-info-divider u-hide-on-desktop" />
        <ShopLocation
          shopName={shop.name}
          phone={shop.phone}
          line1={address.line1}
          line2={address.line2}
          map={shop.staticMap.url}
          directions={address.directions}
        />
      </div>
      { shop.mobileAppCta && <Cta appLink={appLink} /> }
      { shop.mobileAppCta && <PhonesBackground name="rebook" /> }
      <div className={squireInfoClassName}>
        <SquireInfo
          standalone={!shop.mobileAppCta}
          shopName={shop.name}
          renderAction={PostCtaAction}
        />
      </div>
    </NotificationContent>
    <Footer link={appLink} />
  </div>
);

export default withAppointmentNotification(CustomerRebook);



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerRebook/index.jsx